{
  "title": "Swift Quiver",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level transmutation",
  "level": 5,
  "castingTime": "1 bonus action",
  "range": "Touch",
  "components": "V, S, M (a quiver containing at least one piece of ammunition)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You transmute your quiver so it produces an endless supply of nonmagical ammunition, which seems to leap into your hand when you reach for it.",
    "On each of your turns until the spell ends, you can use a bonus action to make two attacks with a weapon that uses ammunition from the quiver. Each time you make such a ranged attack, your quiver magically replaces the piece of ammunition you used with a similar piece of nonmagical ammunition. Any pieces of ammunition created by this spell disintegrate when the spell ends. If the quiver leaves your possession, the spell ends."
  ],
  "spellLists": ["ranger"]
}
